import { render, staticRenderFns } from "./ShippingIntegrationAddFormHeader.vue?vue&type=template&id=022edb29"
import script from "./ShippingIntegrationAddFormHeader.vue?vue&type=script&lang=js"
export * from "./ShippingIntegrationAddFormHeader.vue?vue&type=script&lang=js"
import style0 from "./ShippingIntegrationAddFormHeader.vue?vue&type=style&index=0&id=022edb29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports